import { logException } from "@wss/error-tracking";
import { useCallback, useEffect, useState } from "react";
import { User } from "~/common/Store/connectUserAndChat";
import fetchProductRecommendationsCarouselItems, {
  ProductRecommendationsResult,
} from "../RecAiCarousel/fetchProductRecommendationsCarouselItems";
import { RecAiPage } from "../RecAiCarousel/definition";
import { getDynamicData } from "~/common/Store/actions/updateUserAndChatFromOrigin";

export function useRecommendationCarouselItems(user: User) {
  const [state, setState] = useState<ProductRecommendationsResult>();
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  const getRecommendationCarouselItems = useCallback(async () => {
    if (user.index === undefined) return;
    const result = await fetchProductRecommendationsCarouselItems(
      {
        sessionId: user.sessionId,
        emailAddress: user.emailAddress,
        registered: user.registered,
      },
      RecAiPage.Home,
    );

    if (result.isError) return logException(result.error);
    return setState(result.value);
  }, [user.emailAddress, user.index, user.registered, user.sessionId]);

  useEffect(function waitForUserToLoad() {
    getDynamicData.then((result) => {
      if (result.isError) return;
      setIsInitialized(true);
    });
  }, []);

  useEffect(
    function initGetRecommendationCarouselItems() {
      if (!isInitialized) return;
      getRecommendationCarouselItems();
    },
    [getRecommendationCarouselItems, isInitialized],
  );

  return [state, setState] as const;
}
